import type { Components } from '@mildang/mui';

const createPaper = (): Components => ({
  MuiPaper: {
    styleOverrides: {
      rounded: {
        borderRadius: 8,
      },
    },
  },
});

export default createPaper;
